interface PopupState {
  activeModalId?: string;
}

class PopupManager {
  private triggers: NodeListOf<HTMLElement>;
  private modals: NodeListOf<HTMLElement>;
  private closeButtons: NodeListOf<HTMLElement>;
  private activeModal: HTMLElement | null = null;
  private state: PopupState = {};
  private isEditor: boolean;
  private closeTimeout: NodeJS.Timeout | null = null;

  constructor() {
    // @ts-expect-error Shopify isn't globally defined for us
    this.isEditor = window.Shopify?.designMode || false;
    this.initializeElements();
    this.init();

    if (this.isEditor) {
      this.initEditorHandlers();
    }
  }

  private initializeElements() {
    this.triggers = document.querySelectorAll("[data-modal-trigger]");
    this.modals = document.querySelectorAll("[data-modal]");
    this.closeButtons = document.querySelectorAll("[data-modal-close]");
  }

  private init() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => this.openModal(trigger.dataset.modalTrigger));
    });

    this.closeButtons.forEach((button) => {
      button.addEventListener("click", () => this.closeModal());
    });

    this.modals.forEach((modal) => {
      modal.addEventListener("click", (e) => {
        if (e.target === modal) {
          this.closeModal();
        }
      });
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") this.closeModal();
    });
  }

  private initEditorHandlers() {
    // Listen for section updates in the editor
    document.addEventListener("shopify:section:load", (event: Event) => {
      const section = (event as CustomEvent).target as HTMLElement;
      if (!section) return;

      // Re-initialize elements for this section
      this.initializeElements();
      this.init();

      // If we had a modal open, reopen it
      if (this.state.activeModalId) {
        this.openModal(this.state.activeModalId);
      }
    });

    // Handle section unload
    document.addEventListener("shopify:section:unload", () => {
      // Store the current modal ID before the section is unloaded
      if (this.activeModal) {
        this.state.activeModalId = this.activeModal.dataset.modal;
      }
    });

    // Handle section deselect in editor
    document.addEventListener("shopify:section:deselect", () => {
      // Close the modal when section is deselected
      this.closeModal();
    });
  }

  private openModal(modalId: string | undefined) {
    if (!modalId) return;

    const lastModal = this.activeModal;

    const modal = document.querySelector(`[data-modal="${modalId}"]`);
    if (!modal) return;

    this.activeModal = modal as HTMLElement;
    this.activeModal.style.zIndex = "";
    this.activeModal.style.background = "";
    document.body.style.overflow = "hidden";
    console.log("Opening modal", modal);
    this.activeModal.classList.add("is-active");

    if (this.isEditor) {
      this.state.activeModalId = modalId;
    }

    if (lastModal) {
      console.log("Closing last modal", lastModal);
      lastModal.style.zIndex = "0";
      lastModal.style.background = "transparent";
      this.closeTimeout = setTimeout(() => {
        this.closeModal(lastModal);
      }, 500);
    }
  }

  private closeModal(modal?: HTMLElement) {
    if (modal) {
      document.body.style.overflow = "";
      modal.classList.remove("is-active");
    } else if (this.activeModal) {
      document.body.style.overflow = "";
      this.activeModal.classList.remove("is-active");
      this.activeModal = null;

      if (this.isEditor) {
        this.state.activeModalId = undefined;
      }
    }
  }
}

export const popup = {
  init: () => {
    new PopupManager();
  }
};
